webpackJsonp([35783957827783],{

/***/ 48:
/***/ (function(module, exports) {

	var requestFrame = (function () {
	  var window = this
	  var raf = window.requestAnimationFrame ||
	    window.mozRequestAnimationFrame ||
	    window.webkitRequestAnimationFrame ||
	    function fallbackRAF(func) {
	      return window.setTimeout(func, 20)
	    }
	  return function requestFrameFunction(func) {
	    return raf(func)
	  }
	})()
	
	var cancelFrame = (function () {
	  var window = this
	  var cancel = window.cancelAnimationFrame ||
	    window.mozCancelAnimationFrame ||
	    window.webkitCancelAnimationFrame ||
	    window.clearTimeout
	  return function cancelFrameFunction(id) {
	    return cancel(id)
	  }
	})()
	
	function resizeListener(e) {
	  var win = e.target || e.srcElement
	  if (win.__resizeRAF__) {
	    cancelFrame(win.__resizeRAF__)
	  }
	  win.__resizeRAF__ = requestFrame(function () {
	    var trigger = win.__resizeTrigger__
	    trigger.__resizeListeners__.forEach(function (fn) {
	      fn.call(trigger, e)
	    })
	  })
	}
	
	var exports = function exports(element, fn) {
	  var window = this
	  var document = window.document
	  var isIE
	
	  var attachEvent = document.attachEvent
	  if (typeof navigator !== 'undefined') {
	    isIE = navigator.userAgent.match(/Trident/) ||
	      navigator.userAgent.match(/Edge/)
	  }
	
	  function objectLoad() {
	    this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__
	    this.contentDocument.defaultView.addEventListener('resize', resizeListener)
	  }
	
	  if (!element.__resizeListeners__) {
	    element.__resizeListeners__ = []
	    if (attachEvent) {
	      element.__resizeTrigger__ = element
	      element.attachEvent('onresize', resizeListener)
	    } else {
	      if (getComputedStyle(element).position === 'static') {
	        element.style.position = 'relative'
	      }
	      var obj = (element.__resizeTrigger__ = document.createElement('object'))
	      obj.setAttribute(
	        'style',
	        'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;'
	      )
	      obj.setAttribute('class', 'resize-sensor')
	      obj.__resizeElement__ = element
	      obj.onload = objectLoad
	      obj.type = 'text/html'
	      if (isIE) {
	        element.appendChild(obj)
	      }
	      obj.data = 'about:blank'
	      if (!isIE) {
	        element.appendChild(obj)
	      }
	    }
	  }
	  element.__resizeListeners__.push(fn)
	}
	
	module.exports = typeof window === 'undefined' ? exports : exports.bind(window)
	
	module.exports.unbind = function (element, fn) {
	  var attachEvent = document.attachEvent
	  if (fn) {
	    element.__resizeListeners__.splice(
	      element.__resizeListeners__.indexOf(fn),
	      1
	    )
	  } else {
	    element.__resizeListeners__ = []
	  }
	  if (!element.__resizeListeners__.length) {
	    if (attachEvent) {
	      element.detachEvent('onresize', resizeListener)
	    } else {
	      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener(
	        'resize',
	        resizeListener
	      )
	      delete element.__resizeTrigger__.contentDocument.defaultView.__resizeTrigger__
	      element.__resizeTrigger__ = !element.removeChild(
	        element.__resizeTrigger__
	      )
	    }
	    delete element.__resizeListeners__
	  }
	}


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	var now = __webpack_require__(53)
	  , global = typeof window === 'undefined' ? {} : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = global['request' + suffix]
	  , caf = global['cancel' + suffix] || global['cancelRequest' + suffix]
	  , isNative = true
	
	for(var i = 0; i < vendors.length && !raf; i++) {
	  raf = global[vendors[i] + 'Request' + suffix]
	  caf = global[vendors[i] + 'Cancel' + suffix]
	      || global[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  isNative = false
	
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  if(!isNative) {
	    return raf.call(global, fn)
	  }
	  return raf.call(global, function() {
	    try{
	      fn.apply(this, arguments)
	    } catch(e) {
	      setTimeout(function() { throw e }, 0)
	    }
	  })
	}
	module.exports.cancel = function() {
	  caf.apply(global, arguments)
	}


/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.6.3
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/*
	//@ sourceMappingURL=performance-now.map
	*/
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	var ReactDOM = __webpack_require__(55);
	var elementResizeEvent = __webpack_require__(48);
	
	module.exports = {
	  getInitialState: function() {
	    if (this.props.initialComponentWidth !== undefined && this.props.initialComponentWidth !== null) {
	      return {
	        componentWidth: this.props.initialComponentWidth
	      };
	    } else {
	      return {};
	    }
	  },
	  // Add our resize sensor.
	  componentDidMount: function() {
	    this.setState({
	      componentWidth: ReactDOM.findDOMNode(this).getBoundingClientRect().width
	    });
	    elementResizeEvent(ReactDOM.findDOMNode(this), this.onResize);
	  },
	  // When the DOM updates, check that our resize sensor is still there.
	  componentDidUpdate: function() {
	    if (0 === ReactDOM.findDOMNode(this).getElementsByClassName('resize-sensor').length) {
	      elementResizeEvent(ReactDOM.findDOMNode(this), this.onResize);
	    }
	  },
	  onResize: function() {
	    this.setState({
	      componentWidth: ReactDOM.findDOMNode(this).getBoundingClientRect().width
	    });
	  }
	};


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.2
	var resizeListener;
	
	resizeListener = __webpack_require__(61);
	
	module.exports = {
	  getInitialState: function() {
	    if (this.props.initialPageWidth) {
	      return {
	        pageWidth: this.props.initialPageWidth
	      };
	    } else {
	      return {};
	    }
	  },
	  componentDidMount: function() {
	    return resizeListener.on(this.onResize);
	  },
	  componentWillUnmount: function() {
	    return resizeListener.off(this.onResize);
	  },
	  onResize: function(pageWidth) {
	    return this.setState({
	      pageWidth: pageWidth
	    });
	  }
	};


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.2
	var currentWidth, onResize, raf, subscribers, ticking, update;
	
	raf = __webpack_require__(52);
	
	currentWidth = void 0;
	
	subscribers = [];
	
	ticking = false;
	
	if (typeof window !== "undefined" && window !== null) {
	  currentWidth = window.innerWidth;
	}
	
	onResize = function() {
	  if (!ticking) {
	    ticking = true;
	    return raf(update);
	  }
	};
	
	update = function() {
	  var i, len, subscriber;
	  currentWidth = window.innerWidth;
	  for (i = 0, len = subscribers.length; i < len; i++) {
	    subscriber = subscribers[i];
	    subscriber(currentWidth);
	  }
	  return ticking = false;
	};
	
	if (typeof window !== "undefined" && window !== null) {
	  window.addEventListener("resize", onResize);
	}
	
	module.exports = {
	  on: function(subscribeFn) {
	    subscribeFn(currentWidth);
	    return subscribers.push(subscribeFn);
	  },
	  off: function(subscribeFn) {
	    return subscribers.splice(subscribers.indexOf(subscribeFn), 1);
	  }
	};


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var ComponentWidthComponent, PageWidthComponent, PageWidthMixin, React, componentWidthMixin, objectAssign;
	
	React = __webpack_require__(3);
	
	componentWidthMixin = __webpack_require__(54);
	
	PageWidthMixin = __webpack_require__(60);
	
	objectAssign = __webpack_require__(2);
	
	ComponentWidthComponent = React.createClass({
	  displayName: "Breakpoint",
	  mixins: [componentWidthMixin],
	  propTypes: {
	    minWidth: React.PropTypes.number,
	    maxWidth: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      minWidth: 0,
	      maxWidth: 1000000000000000000000
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref;
	        if ((child != null ? (ref = child.type) != null ? ref.displayName : void 0 : void 0) === "Span") {
	          return React.cloneElement(child, {
	            context: _this.props.context
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props, ref;
	    props = objectAssign({}, this.props);
	    delete props.maxWidth;
	    delete props.minWidth;
	    delete props.widthMethod;
	    if (this.state.componentWidth) {
	      if ((this.props.minWidth <= (ref = this.state.componentWidth) && ref < this.props.maxWidth)) {
	        return React.createElement("div", Object.assign({}, props), this.renderChildren());
	      } else {
	        return React.createElement("div", null);
	      }
	    } else {
	      return React.createElement("div", null);
	    }
	  }
	});
	
	PageWidthComponent = React.createClass({
	  displayName: "Breakpoint",
	  mixins: [PageWidthMixin],
	  propTypes: {
	    minWidth: React.PropTypes.number,
	    maxWidth: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      minWidth: 0,
	      maxWidth: 1000000000000000000000
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref;
	        if (((ref = child.type) != null ? ref.displayName : void 0) === "Span") {
	          return React.cloneElement(child, {
	            context: _this.props.context
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props, ref;
	    props = objectAssign({}, this.props);
	    delete props.maxWidth;
	    delete props.minWidth;
	    delete props.widthMethod;
	    if (this.state.pageWidth) {
	      if ((this.props.minWidth <= (ref = this.state.pageWidth) && ref < this.props.maxWidth)) {
	        return React.createElement("div", Object.assign({}, props), this.renderChildren());
	      } else {
	        return React.createElement("div", null);
	      }
	    } else {
	      return React.createElement("div", null);
	    }
	  }
	});
	
	module.exports = React.createClass({
	  displayName: 'Breakpoint',
	  propTypes: {
	    widthMethod: React.PropTypes.string.isRequired,
	    minWidth: React.PropTypes.number,
	    maxWidth: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      widthMethod: 'pageWidth'
	    };
	  },
	  render: function() {
	    if (this.props.widthMethod === "pageWidth") {
	      return React.createElement(PageWidthComponent, Object.assign({}, this.props));
	    } else if (this.props.widthMethod === "componentWidth") {
	      return React.createElement(ComponentWidthComponent, Object.assign({}, this.props));
	    }
	  }
	});


/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var React, objectAssign;
	
	React = __webpack_require__(3);
	
	objectAssign = __webpack_require__(2);
	
	module.exports = React.createClass({
	  displayName: "Container",
	  render: function() {
	    var children, defaultStyles, props, styles;
	    defaultStyles = {
	      maxWidth: '960px',
	      marginLeft: 'auto',
	      marginRight: 'auto'
	    };
	    styles = objectAssign(defaultStyles, this.props.style);
	    children = this.props.children;
	    props = objectAssign({}, this.props);
	    delete props.children;
	    delete props.style;
	    return React.createElement("div", Object.assign({}, props, {
	      "style": styles
	    }), children, React.createElement("span", {
	      "style": {
	        display: 'block',
	        clear: 'both'
	      }
	    }, ' '));
	  }
	});


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var React, objectAssign;
	
	React = __webpack_require__(3);
	
	objectAssign = __webpack_require__(2);
	
	module.exports = React.createClass({
	  displayName: "Grid",
	  propTypes: {
	    columns: React.PropTypes.number,
	    gutterRatio: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      columns: 12,
	      gutterRatio: 1 / 4
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref, ref1;
	        if ((ref = (ref1 = child.type) != null ? ref1.displayName : void 0) === "Breakpoint" || ref === "Span") {
	          return React.cloneElement(child, {
	            context: {
	              columns: _this.props.columns,
	              gutterRatio: _this.props.gutterRatio
	            }
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props;
	    props = objectAssign({}, this.props);
	    delete props.gutterRatio;
	    delete props.columns;
	    return React.createElement("div", Object.assign({}, props), this.renderChildren(), React.createElement("span", {
	      "style": {
	        display: 'block',
	        clear: 'both'
	      }
	    }, ' '));
	  }
	});


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var React, objectAssign, spanCalculate;
	
	React = __webpack_require__(3);
	
	objectAssign = __webpack_require__(2);
	
	spanCalculate = __webpack_require__(67);
	
	module.exports = React.createClass({
	  displayName: "Span",
	  propTypes: {
	    context: React.PropTypes.object,
	    columns: React.PropTypes.number,
	    at: React.PropTypes.number,
	    pre: React.PropTypes.number,
	    post: React.PropTypes.number,
	    squish: React.PropTypes.number,
	    last: React.PropTypes.bool,
	    "break": React.PropTypes.bool
	  },
	  getDefaultProps: function() {
	    return {
	      at: 0,
	      pre: 0,
	      post: 0,
	      squish: 0,
	      last: false,
	      first: false,
	      "break": false
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref;
	        if ((child != null ? (ref = child.type) != null ? ref.displayName : void 0 : void 0) === "Span") {
	          return React.cloneElement(child, {
	            context: {
	              columns: _this.props.columns,
	              gutterRatio: _this.props.context.gutterRatio
	            }
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props, style;
	    style = spanCalculate({
	      contextColumns: this.props.context.columns,
	      gutterRatio: this.props.context.gutterRatio,
	      columns: this.props.columns,
	      at: this.props.at,
	      pre: this.props.pre,
	      post: this.props.post,
	      squish: this.props.squish,
	      last: this.props.last,
	      "break": this.props["break"]
	    });
	    style = objectAssign(style, this.props.style);
	    props = objectAssign({}, this.props, {
	      "style": style
	    });
	    delete props.at;
	    delete props["break"];
	    delete props.columns;
	    delete props.context;
	    delete props.first;
	    delete props.last;
	    delete props.post;
	    delete props.pre;
	    delete props.squish;
	    delete props.style;
	    return React.createElement("div", Object.assign({}, props, {
	      "style": style
	    }), this.renderChildren(), React.createElement("span", {
	      "style": {
	        display: 'block',
	        clear: 'both'
	      }
	    }, ' '));
	  }
	});


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	exports.Container = __webpack_require__(63);
	
	exports.Grid = __webpack_require__(64);
	
	exports.Breakpoint = __webpack_require__(62);
	
	exports.Span = __webpack_require__(65);


/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var objectAssign;
	
	objectAssign = __webpack_require__(2);
	
	module.exports = function(options) {
	  var calcSpacing, calcSpanWidth, defaults, float, gutterWidth, marginLeft, marginRight, n, ops, width;
	  defaults = {
	    columns: 3,
	    at: 0,
	    pre: 0,
	    post: 0,
	    squish: 0,
	    contextColumns: 12,
	    gutterRatio: 1 / 4,
	    first: false,
	    last: false
	  };
	  ops = objectAssign(defaults, options);
	  n = 100 / (ops.contextColumns + ((ops.contextColumns - 1) * ops.gutterRatio));
	  gutterWidth = ops.gutterRatio * n;
	  calcSpanWidth = function(numColumns) {
	    return n * numColumns + gutterWidth * (numColumns - 1);
	  };
	  calcSpacing = function(numColumns) {
	    if (numColumns === 0) {
	      return 0;
	    } else {
	      return calcSpanWidth(numColumns) + gutterWidth;
	    }
	  };
	  width = calcSpanWidth(ops.columns);
	  if (ops.at === 0 && ops.pre === 0 && ops.squish === 0) {
	    marginLeft = 0;
	  } else {
	    marginLeft = calcSpacing(ops.at) + calcSpacing(ops.pre) + calcSpacing(ops.squish);
	  }
	  if (ops.last && ops.post === 0 && ops.squish === 0) {
	    marginRight = 0;
	  } else if (ops.post !== 0 || ops.squish !== 0) {
	    marginRight = calcSpacing(ops.post) + calcSpacing(ops.squish);
	    if (!ops.last) {
	      marginRight = marginRight + gutterWidth;
	    }
	  } else {
	    marginRight = gutterWidth;
	  }
	  if (ops.last) {
	    float = "right";
	  } else {
	    float = "left";
	  }
	  width = width + "%";
	  marginLeft = marginLeft + "%";
	  marginRight = marginRight + "%";
	  return {
	    float: float,
	    marginLeft: marginLeft,
	    marginRight: marginRight,
	    width: width,
	    clear: ops["break"] ? 'both' : 'none'
	  };
	};


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(118);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactResponsiveGrid = __webpack_require__(66);
	
	var _typography = __webpack_require__(70);
	
	var _avatar = __webpack_require__(153);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _keybase = __webpack_require__(154);
	
	var _keybase2 = _interopRequireDefault(_keybase);
	
	var _linkedin = __webpack_require__(155);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _aboutModule = __webpack_require__(116);
	
	var _aboutModule2 = _interopRequireDefault(_aboutModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var keybaseLogoStyle = {
	    height: "28px"
	};
	var linkedInLogoStyle = {
	    height: "28px"
	};
	
	var linkNoBoxShadowStyle = {
	    boxShadow: "none"
	};
	
	var AboutPage = function (_Component) {
	    _inherits(AboutPage, _Component);
	
	    function AboutPage() {
	        _classCallCheck(this, AboutPage);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	        _this.state = {
	            messageFrameVisible: false
	        };
	        return _this;
	    }
	
	    AboutPage.prototype.showMessageFrame = function showMessageFrame() {
	        this.setState({ messageFrameVisible: true });
	    };
	
	    AboutPage.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            _reactResponsiveGrid.Container,
	            {
	                style: {
	                    maxWidth: (0, _typography.rhythm)(24),
	                    padding: (0, _typography.rhythm)(1.5) + ' ' + (0, _typography.rhythm)(3 / 4),
	                    margin: "20vh auto"
	                },
	                className: _aboutModule2.default.card
	            },
	            _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        display: "flex",
	                        flexDirection: "column",
	                        justifyContent: "flex-start"
	                    }
	                },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('img', { src: _avatar2.default, className: _aboutModule2.default.avatar })
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    {
	                        style: {
	                            marginTop: '' + (0, _typography.rhythm)(0.5)
	                        }
	                    },
	                    'Hi, I am ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Biswa'
	                    ),
	                    '; a software dev currently ',
	                    _react2.default.createElement('br', null),
	                    'in Sydney, Australia'
	                ),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        style: {
	                            display: "flex",
	                            flexDirection: "row",
	                            justifyContent: "flex-start"
	                        }
	                    },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        'You can reach me at:'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            style: {
	                                display: "flex",
	                                flexGrow: "2",
	                                flexWrap: "wrap",
	                                flexDirection: "row",
	                                justifyContent: "space-evenly",
	                                minWidth: "100px"
	                            }
	                        },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://www.linkedin.com/in/biswadahal', style: linkNoBoxShadowStyle },
	                            _react2.default.createElement('img', { src: _linkedin2.default, style: linkedInLogoStyle })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://keybase.io/biswadahal', style: linkNoBoxShadowStyle },
	                            _react2.default.createElement('img', { src: _keybase2.default, style: keybaseLogoStyle })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Or, ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#msg', onClick: function onClick() {
	                                        return _this2.showMessageFrame();
	                                    } },
	                                'Send a message'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { id: 'msg',
	                    className: this.state.messageFrameVisible === true ? _aboutModule2.default.showMsg : _aboutModule2.default.hideMsg
	                },
	                _react2.default.createElement(
	                    'iframe',
	                    {
	                        src: 'https://docs.google.com/forms/d/e/1FAIpQLSdkc7xPaXXhEB8VPkhCZMYOXTeoxYxUlMsQep0RYEBF4ZdrpA/viewform?embedded=true',
	                        className: _aboutModule2.default.messageForm,
	                        scrolling: 'no',
	                        frameborder: '0',
	                        marginheight: '0',
	                        marginwidth: '0' },
	                    'Loading Message Form...'
	                )
	            )
	        );
	    };
	
	    return AboutPage;
	}(_react.Component);
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"card":"src-components----about-module---card---Ek2_n","avatar":"src-components----about-module---avatar---2nu7V","messageForm":"src-components----about-module---messageForm---il1h1","hideMsg":"src-components----about-module---hideMsg---2sIU8","showMsg":"src-components----about-module---showMsg---2sW71","fadein":"src-components----about-module---fadein---nVrEG"};

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/avatar.dc5bc9bc.jpg";

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _about = __webpack_require__(96);
	
	var _about2 = _interopRequireDefault(_about);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(_about2.default, null);
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-1e2e4ace26c43da890fc.js